import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Alert from "@amzn/meridian/alert";

class ErrorPage extends Component {
    render() {
        return (
            <Alert
                type="error"
                size="takeover"
            >
                <FormattedMessage id="induct.error" defaultMessage="Some Error Occured">
                </FormattedMessage>
            </Alert>
        )
    };
}

export default ErrorPage;


// WEBPACK FOOTER //
// ./src/components/error/ErrorPage.js